//===========================================================
// #1 - Base Imports
//===========================================================
import React from "react";
import { Link, useHistory } from "react-router-dom";

//===========================================================
// #2 - Import * FontAwesome Icons
//===========================================================
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-light-svg-icons";

import ProductPlaceholder from "../../../assets/images/placeholders/partner-logo-160x130.png";

export const AdvertiserCard = (props) => {

    const history = useHistory();

    return (

        <Link to={{ pathname: props.storeId ? `/parceiro` : '', search: `${history.location.search}&partnerId=${props.storeId}` }} className="_advertiser-card">
            <div className="_col">

                <div to={"/loja/"} className="_advertiser-card-logo">
                    <img
                        onError={(e) => e.target.src = ProductPlaceholder}
                        src={props.storeLogo}
                        alt="Avatar"
                    />
                </div>

                <div className="_advertiser-card-title--location">
                    {props.storeTitle}
                    <span className="title-location"> {props.storeLocation} </span>
                </div>

            </div>

            <div className="_col">

                {props.button === true && (
                    <div className="_advertiser-card-follow">
                        <button type="button" className="btn btn-follow">
                            Ver loja
                        </button>
                    </div>
                )}

                {props.redirectButton && (
                    <div className="_advertiser-card-redirect">
                        <button type="button" className="btn">
                            <FontAwesomeIcon icon={faChevronRight}></FontAwesomeIcon>
                        </button>
                    </div>
                )}

            </div>
        </Link>

    )
};